
timeParseDirective = (moment) ->
    'ngInject'

    restrict: 'A'
    require: 'ngModel'
    scope: format: '=?'

    link: (scope, element, attrs, ngModel) ->
        if not scope.format?
            scope.format = ['h:mmA', 'H:mm']

        ngModel.$parsers.push (value) ->
            if not value? or value == "" then return value
            return moment(value, scope.format)

        ngModel.$formatters.push (value) ->
            format = if angular.isArray(scope.format) then scope.format[0] else scope.format
            if moment.isMoment(value) then return value.format(format)
            else return value

        ngModel.$validators.time = (modelValue, viewValue) ->
            if not modelValue? or modelValue == "" then return true
            moment.isMoment(modelValue) and modelValue.isValid()


module.directive('timeParse', timeParseDirective)
